/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PresentationParams { 
    /**
     * Json Web Token. Provides the data required to obtain information from a presentation and verify it. Format Header.Payload.Signature.
     */
    jwt?: string;
    /**
     * Register presentation transaction signed by the subject. This transaction must contain the subjectPresentationHash to store it on the blockchain for this subject. Encoded in Base64 format
     */
    subjectPresentationTransactionSigned: PresentationParams.SubjectPresentationTransactionSignedEnum;
}
export namespace PresentationParams {
    export const SubjectPresentationTransactionSignedEnum = {
        B27b2faa6: '[B@27b2faa6'
    } as const;
    export type SubjectPresentationTransactionSignedEnum = typeof SubjectPresentationTransactionSignedEnum[keyof typeof SubjectPresentationTransactionSignedEnum];
}


